var map = {
	"./layouts/dashboard/dashboard.module": [
		"./src/app/layouts/dashboard/dashboard.module.ts"
	],
	"./views/auth/auth.module": [
		"./src/app/views/auth/auth.module.ts",
		"default~views-auth-auth-module~views-countries-countries-module~views-factories-factories-module~vie~7b3d0db8",
		"common",
		"views-auth-auth-module"
	],
	"./views/countries/countries.module": [
		"./src/app/views/countries/countries.module.ts",
		"default~views-auth-auth-module~views-countries-countries-module~views-factories-factories-module~vie~7b3d0db8",
		"common",
		"views-countries-countries-module"
	],
	"./views/factories/factories.module": [
		"./src/app/views/factories/factories.module.ts",
		"default~views-auth-auth-module~views-countries-countries-module~views-factories-factories-module~vie~7b3d0db8",
		"common",
		"views-factories-factories-module"
	],
	"./views/products/products.module": [
		"./src/app/views/products/products.module.ts",
		"default~views-auth-auth-module~views-countries-countries-module~views-factories-factories-module~vie~7b3d0db8",
		"common",
		"views-products-products-module"
	],
	"./views/stock/stock.module": [
		"./src/app/views/stock/stock.module.ts",
		"default~views-auth-auth-module~views-countries-countries-module~views-factories-factories-module~vie~7b3d0db8",
		"common",
		"views-stock-stock-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;